import React from "react";

const NAVY = "#0B1F3A";
const BLUE = "#184E9E";
const GOLD = "#D4AF37";

/* ------------------------------------------------------------------ MARKS -- */

// Option 1 — Monogram Badge: a solid navy badge with a bold "BE" and gold bar.
export function MarkBadge({ size = 64, onDark = false }) {
  const badge = onDark ? "#FFFFFF" : NAVY;
  const letter = onDark ? NAVY : "#FFFFFF";
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="60" height="60" rx="15" fill={badge} />
      <rect x="2" y="2" width="60" height="60" rx="15" stroke={GOLD} strokeWidth="2.5" fill="none" opacity={onDark ? 0.9 : 0.85} />
      <text x="32" y="40" textAnchor="middle" fontFamily="Poppins, Arial, sans-serif" fontWeight="800" fontSize="30" fill={letter} letterSpacing="-1">BE</text>
      <rect x="18" y="46" width="28" height="4" rx="2" fill={GOLD} />
    </svg>
  );
}

// Option 2 — Ascending Growth Bars: three rising bars, tallest in gold, arrow rising.
export function MarkGrowth({ size = 64, onDark = false }) {
  const b1 = onDark ? "#5b7bb8" : NAVY;
  const b2 = BLUE;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="34" width="12" height="22" rx="4" fill={b1} />
      <rect x="26" y="24" width="12" height="32" rx="4" fill={b2} />
      <rect x="44" y="12" width="12" height="44" rx="4" fill={GOLD} />
      {/* rising arrow */}
      <path d="M10 30 L26 20 L38 24 L54 8" stroke={onDark ? "#FFFFFF" : NAVY} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M47 8 H55 V16" stroke={onDark ? "#FFFFFF" : NAVY} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

// Option 3 — Compliance Shield with a gold check.
export function MarkShield({ size = 64, onDark = false }) {
  const shield = onDark ? "#FFFFFF" : NAVY;
  const check = onDark ? NAVY : GOLD;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 5 L54 13 V31 C54 44 44 54.5 32 59 C20 54.5 10 44 10 31 V13 Z" fill={shield} />
      <path d="M32 5 L54 13 V31 C54 44 44 54.5 32 59 C20 54.5 10 44 10 31 V13 Z" fill="none" stroke={GOLD} strokeWidth="2" opacity={onDark ? 0.7 : 0.55} />
      <path d="M22 32 l7 8 l14 -17" stroke={check} strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

/* --------------------------------------------------------------- WORDMARK -- */
export function Wordmark({ onDark = false, scale = 1 }) {
  const name = onDark ? "#FFFFFF" : NAVY;
  const rest = onDark ? "#E7EAF0" : "#2E2E2E";
  const tag = GOLD;
  return (
    <span className="leading-tight" style={{ transform: `scale(${scale})`, transformOrigin: "left center" }}>
      <span className="block font-head font-extrabold tracking-[0.02em]" style={{ fontSize: 22, color: name }}>
        BEE E<span style={{ color: GOLD }}>X</span><span style={{ color: rest }}>SELLANCE</span>
      </span>
      <span className="flex items-center gap-2 mt-1">
        <span style={{ height: 1.5, width: 16, background: tag }} />
        <span className="font-head font-semibold tracking-[0.22em] uppercase" style={{ fontSize: 8.5, color: onDark ? "#C9D2E2" : NAVY }}>
          Your B-BBEE Advisor
        </span>
        <span style={{ height: 1.5, width: 16, background: tag }} />
      </span>
    </span>
  );
}
